import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const AdminRoute = ({ children }) => {
  const { role, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (role !== 'ADMIN') {
    // If authenticated as USER trying to access admin, redirect to user dashboard
    return <Navigate to="/user" replace />;
  }

  return children;
};

export default AdminRoute;
